import React from "react";
import styled from "styled-components";
import { Prompt, PromptType } from "common/models/types";
import { TypeListState } from "pages/Admin/Prompts/promptListState";
import PromptList from "components/organisms/PromptList";
import PromptInfo from "components/organisms/PromptInfo";

interface PromptsTemplateProps {
  typeCounts: Partial<Record<PromptType, number>>;
  typeLists: Partial<Record<PromptType, TypeListState>>;
  countReliable: boolean;
  countError?: string | null;
  selectedPrompt: Prompt | null;
  isLoadingDetail?: boolean;
  onSelectPrompt: (prompt: Prompt) => void;
  onCreatePrompt?: () => void;
  onExpandType: (type: PromptType) => void;
  onLoadMoreType: (type: PromptType) => void;
  onRetryType: (type: PromptType) => void;
  onToggleActive?: (promptId: number, isActive: boolean) => void;
  onUpdatePrompt?: (prompt: Prompt) => void;
  onReloadPrompt?: (promptId: number) => void;
  onDeletePrompt?: (promptId: number) => void;
}

const Container = styled.div`
  display: flex;
  width: 100%;
  height: calc(100vh - 100px);
`;

const LeftPanel = styled.div`
  flex: 0 0 350px;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 16px;
`;

const RightPanel = styled.div`
  flex: 1;
  height: 100%;
  padding: 16px;
  overflow: hidden;
`;

const PromptsTemplate: React.FC<PromptsTemplateProps> = ({
  typeCounts,
  typeLists,
  countReliable,
  countError,
  selectedPrompt,
  isLoadingDetail,
  onSelectPrompt,
  onCreatePrompt,
  onExpandType,
  onLoadMoreType,
  onRetryType,
  onToggleActive,
  onUpdatePrompt,
  onReloadPrompt,
  onDeletePrompt,
}) => {
  return (
    <Container>
      <LeftPanel>
        <PromptList
          typeCounts={typeCounts}
          typeLists={typeLists}
          countReliable={countReliable}
          countError={countError}
          selectedPrompt={selectedPrompt}
          onSelectPrompt={onSelectPrompt}
          onCreatePrompt={onCreatePrompt ?? (() => {})}
          onExpandType={onExpandType}
          onLoadMoreType={onLoadMoreType}
          onRetryType={onRetryType}
          onToggleActive={onToggleActive}
        />
      </LeftPanel>
      <RightPanel>
        <PromptInfo
          prompt={selectedPrompt}
          onUpdate={onUpdatePrompt}
          onReload={onReloadPrompt}
          isLoading={isLoadingDetail}
          onDelete={onDeletePrompt}
        />
      </RightPanel>
    </Container>
  );
};

export default PromptsTemplate;
